const Clipboard = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6641 2.66634C11.284 2.66634 11.594 2.66634 11.8484 2.73449C12.5386 2.91942 13.0776 3.45852 13.2626 4.1487C13.3307 4.40304 13.3307 4.71303 13.3307 5.33301V11.4663C13.3307 12.5864 13.3307 13.1465 13.1127 13.5743C12.921 13.9506 12.615 14.2566 12.2387 14.4484C11.8109 14.6663 11.2508 14.6663 10.1307 14.6663H5.86406C4.74396 14.6663 4.1839 14.6663 3.75608 14.4484C3.37976 14.2566 3.0738 13.9506 2.88205 13.5743C2.66406 13.1465 2.66406 12.5864 2.66406 11.4663V5.33301C2.66406 4.71303 2.66406 4.40304 2.73221 4.1487C2.91715 3.45852 3.45624 2.91942 4.14642 2.73449C4.40076 2.66634 4.71075 2.66634 5.33073 2.66634M6.3974 3.99967H9.5974C9.97076 3.99967 10.1574 3.99967 10.3001 3.92701C10.4255 3.8631 10.5275 3.76111 10.5914 3.63567C10.6641 3.49306 10.6641 3.30638 10.6641 2.93301V2.39967C10.6641 2.02631 10.6641 1.83962 10.5914 1.69701C10.5275 1.57157 10.4255 1.46959 10.3001 1.40567C10.1574 1.33301 9.97076 1.33301 9.5974 1.33301H6.3974C6.02403 1.33301 5.83734 1.33301 5.69474 1.40567C5.56929 1.46959 5.46731 1.57157 5.40339 1.69701C5.33073 1.83962 5.33073 2.02631 5.33073 2.39967V2.93301C5.33073 3.30638 5.33073 3.49306 5.40339 3.63567C5.46731 3.76111 5.56929 3.8631 5.69474 3.92701C5.83734 3.99967 6.02403 3.99967 6.3974 3.99967Z"
      stroke="#13694E"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Clipboard;
